export const ROLLOUTS = {
    PROJECT_PARTNER_BANNER_ROLLOUT: 'zebras_project_partner_banner_in_vertical_page',
    PROJECT_PARTNER_BANNER_IN_MARKETPLACE_ROLLOUT: 'zebras_project_partner_banner_in_marketplace',
    MEERKATS_VERTICAL_PAGE_CATEGORY_BUILDER: 'meerkats_vertical_page_category_builder',
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',
} as const;
